export default __webpack_public_path__ + "static/media/DOM-JULY-2024.fb8bd137.png";